module.exports = __webpack_public_path__ + "static/media/image003.e59fa888.jpg";